import React, { useState } from 'react';
import Logo from '../img/head_logo_nombre.png';
import '../styles/Login.css';
import { login } from '../utils/api';

interface LoginProps {
  onSuccess: (programCode: string, isAdmin: boolean, token: string) => void;
  currentLang: 'es' | 'en';
  onLangChange: (lang: 'es' | 'en') => void;
}

const Login: React.FC<LoginProps> = ({ onSuccess, currentLang, onLangChange }) => {
  // Función de traducción
  const t = (es: string, en: string) => (currentLang === 'es' ? es : en);
  const [correo, setCorreo] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    try {
      const emailStr = String(correo);
      const passStr = String(password);
      const res = await login(emailStr, passStr);
      if (res.result) {
        onSuccess(res.codigo_programa, res.admin, res.token);
      } else {
        setError(t('Credenciales incorrectas.', 'Incorrect credentials.'));
      }
    } catch (err) {
      console.error(err);
      setError(t('Error en el servidor.', 'Server error.'));
    }
  };

  return (
    <div className="login-page">
      <div className="login-box">
        <img src={Logo} alt="Logo" className="login-logo" />
        
       
        <form onSubmit={handleSubmit}>
          <div>
            <label>{t('Correo:', 'Email:')}</label>
            <input
              type="email"
              value={correo}
              onChange={e => setCorreo(e.target.value)}
              required
            />
          </div>
          <div>
            <label>{t('Código de acceso:', 'Access Code:')}</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
            />
          </div>
          {error && <p className="error">{error}</p>}
          <button type="submit">{t('Entrar', 'Enter')}</button>
        </form>
      </div>
    </div>
  );
};

export default Login; 